// extracted by mini-css-extract-plugin
module.exports = {"option":"Detailed_option__Zywmq","title":"Detailed_title__GJgIL","fields":"Detailed_fields__kFV2r","field":"Detailed_field__3TsK-","label":"Detailed_label__33uoF"};